import React from "react"
import {
  Checkbox,
  TextField,
  Typography,
  Box,
  FormControl,
  MenuItem,
  Select,
  Button,
  Dialog,
  DialogContent,
  Divider,
  IconButton,
  FormHelperText,
  styled
} from "@mui/material"
import CloseRoundedIcon from "@mui/icons-material/CloseRounded"
import EducationModalController, { Props } from "./EducationModalController.web"
import { configJSON } from "./CustomisableUserProfilesController"
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded"
import FullPageLoader from "../../../components/src/FullPageLoader.web"

const CustomDialog = styled(Dialog)({
  "& .MuiPaper-root": {
    borderRadius: "20px",
    backgroundColor: "#fff",
    padding: "10px"
  },
});

export default class EducationModal extends EducationModalController {
  constructor(props: Props) {
    super(props)
    // Customizable Area Start
    // Customizable Area End
  }

  render() {
    const { isLoading } = this.state
    const currentYear = new Date().getFullYear()
    const yearOptions: number[] = Array.from(
      { length: currentYear - 1970 + 1 },
      (_, i) => 1970 + i
    )
    return (
      <>
      <FullPageLoader isLoading={isLoading} />
      <CustomDialog
        fullWidth
        maxWidth="md"
        disableRestoreFocus
        data-test-id="handleEducationModal"
        open={this.props.open}
        onClose={this.props.onClose}
      >
        <DialogContent>
        <Box sx={{ ...webStyles.modalwebStyles }}>
          <Box sx={{ ...webStyles.modalTitleTypoBox }}>
            <Typography variant="h6" sx={{ ...webStyles.modalTitleTypo }}>
              Add Education and Training
            </Typography>
            <IconButton
              data-test-id="modalClose"
              onClick={this.props.onClose}
              sx={{ ...webStyles.closeIcon }}
            >
              <CloseRoundedIcon />
            </IconButton>
          </Box>
          <Divider />
          <Box>
            <Box sx={{ ...webStyles.projectMainContainer }}>
              <Box style={{ width: "100%" }}>
                <Typography sx={{ ...webStyles.fieldsTitleTypo }}>
                  Institute Name <span style={{ color: "#ff0000" }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  placeholder="Enter your Institute name"
                  variant="outlined"
                  value={this.state.instituteName}
                  name="instituteName"
                  sx={{ ...webStyles.inputField }}
                  onChange={this.handleLocationChange}
                  error={!!this.state.errors.instituteName}
                  helperText={this.state.errors.instituteName}
                  data-test-id="institutesName"
                />
              </Box>
              <Box style={{ width: "100%" }}>
                <Typography sx={{ ...webStyles.fieldsTitleTypo }}>
                  Qualification <span style={{ color: "#ff0000" }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  placeholder="Enter your Qualification"
                  variant="outlined"
                  value={this.state.qualification}
                  name="qualification"
                  sx={{ ...webStyles.inputField }}
                  onChange={this.handleQualificationChange}
                  error={!!this.state.errors.qualification}
                  helperText={this.state.errors.qualification}
                  data-test-id="qualification"
                />
              </Box>
            </Box>
            <Typography sx={{ ...webStyles.fieldsTitleTypo }}>
              Start Date <span style={{ color: "#ff0000" }}>*</span>
            </Typography>
            <Box sx={{ ...webStyles.projectBox }}>
              <Box style={{ width: "100%" }}>
                <FormControl fullWidth sx={{ ...webStyles.inputField }}>
                  <Select
                    name="instituteMonth"
                    data-test-id="institute-month"
                    onChange={this.handleInstituteMonthChange}
                    value={this.state.instituteMonth}
                    IconComponent={KeyboardArrowDownRoundedIcon}
                    defaultValue=""
                    displayEmpty
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxHeight: 200,
                          overflowY: "auto",
                          minWidth: "unset",
                        },
                      },
                      sx: {
                        "& .MuiPaper-root": {
                          width: "auto !important",
                          minWidth: "100%",
                        },
                      },
                    }}
                  >
                    <MenuItem value="" sx={{ display: "none" }}>
                      {" "}
                      Month{" "}
                    </MenuItem>
                    {configJSON.monthName.map(
                      (month: { key: string; value: string }) => (
                        <MenuItem key={month.key} value={month.value}>
                          {month.value}
                        </MenuItem>
                      )
                    )}
                  </Select>
                </FormControl>
                {this.state.errors.instituteMonth && (
                  <FormHelperText style={{ color: "#d32f2f" }}>
                    {this.state.errors.instituteMonth}
                  </FormHelperText>
                )}
              </Box>
              <Box style={{ width: "100%" }}>
                <FormControl fullWidth sx={{ ...webStyles.inputField }}>
                  <Select
                    data-test-id="institute-year"
                    name="instituteYear"
                    value={this.state.instituteYear}
                    onChange={this.handleInstituteYearChange}
                    IconComponent={KeyboardArrowDownRoundedIcon}
                    defaultValue=""
                    displayEmpty
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxHeight: 200,
                          overflowY: "auto",
                          minWidth: "unset",
                        },
                      },
                      sx: {
                        "& .MuiPaper-root": {
                          width: "auto !important",
                          minWidth: "100%",
                        },
                      },
                    }}
                  >
                    <MenuItem value="" sx={{ display: "none" }}>
                      {" "}
                      Year{" "}
                    </MenuItem>
                    {yearOptions.map((year) => (
                      <MenuItem key={year} value={year}>
                        {" "}
                        {year}{" "}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {this.state.errors.instituteYear && (
                  <FormHelperText style={{ color: "#d32f2f" }}>
                    {this.state.errors.instituteYear}
                  </FormHelperText>
                )}
              </Box>
            </Box>
            <Typography sx={{ ...webStyles.fieldsTitleTypo }}>
              End Date
            </Typography>
            <Box sx={{ ...webStyles.projectBox }}>
              <Box style={{ width: "100%" }}>
                <FormControl fullWidth sx={{ ...webStyles.inputField }}>
                  <Select
                    data-test-id="end-month-select"
                    name="instituteEndMonth"
                    value={this.state.instituteEndMonth}
                    onChange={this.handleEndMonthChange}
                    IconComponent={KeyboardArrowDownRoundedIcon}
                    disabled={this.state.ongoing}
                    defaultValue=""
                    displayEmpty
                    MenuProps={{
                      sx: {
                        "& .MuiPaper-root": {
                          width: "auto !important",
                          minWidth: "100%",
                        },
                      },
                      PaperProps: {
                        sx: {
                          maxHeight: 200,
                          overflowY: "auto",
                          minWidth: "unset",
                        },
                      },
                    }}
                  >
                    <MenuItem value="" sx={{ display: "none" }}>
                      Month
                    </MenuItem>
                    {configJSON.monthName.map(
                      (month: { key: string; value: string }) => (
                        <MenuItem key={month.key} value={month.value}>
                          {month.value}
                        </MenuItem>
                      )
                    )}
                  </Select>
                </FormControl>
                {this.state.errors.instituteEndMonth && (
                  <FormHelperText style={{ color: "#d32f2f" }}>
                    {this.state.errors.instituteEndMonth}
                  </FormHelperText>
                )}
              </Box>
              <Box style={{ width: "100%" }}>
                <FormControl fullWidth sx={{ ...webStyles.inputField }}>
                  <Select
                    data-test-id="end-year-select"
                    name="instituteEndYear"
                    value={this.state.instituteEndYear}
                    defaultValue=""
                    displayEmpty
                    onChange={this.handleEndYearChange}
                    IconComponent={KeyboardArrowDownRoundedIcon}
                    disabled={this.state.ongoing}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          minWidth: "unset",
                          overflowY: "auto",
                          maxHeight: 200,
                        },
                      },
                      sx: {
                        "& .MuiPaper-root": {
                          width: "auto !important",
                          minWidth: "100%",
                        },
                      },
                    }}
                  >
                    <MenuItem value="" sx={{ display: "none" }}>
                      Year
                    </MenuItem>
                    {yearOptions.map((year) => (
                      <MenuItem key={year} value={year}>
                        {year}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {this.state.errors.instituteEndYear && (
                  <FormHelperText style={{ color: "#d32f2f" }}>
                    {this.state.errors.instituteEndYear}
                  </FormHelperText>
                )}
              </Box>
            </Box>
            <Box sx={{ ...webStyles.checkboxDivBox }}>
              <Checkbox
                data-test-id="ongoingCheckbox"
                icon={<this.CustomUncheckedIcon />}
                checkedIcon={<this.CustomCheckedIcon />}
                checked={this.state.ongoing}
                onChange={this.handleCheckboxChange}
              />
              <Typography sx={{ ...webStyles.checkBoxTitleText }}>
                Ongoing
              </Typography>
            </Box>
            <Box sx={{ ...webStyles.projectBox }}>
              <Box style={{ width: "100%" }}>
                <Typography sx={{ ...webStyles.fieldsTitleTypo }}>
                  Location <span style={{ color: "#ff0000" }}>*</span>
                </Typography>
                <TextField
                  name="location"
                  data-test-id="location"
                  value={this.state.location}
                  onChange={this.handleLocationChange}
                  variant="outlined"
                  sx={{ ...webStyles.inputField }}
                  error={!!this.state.errors.location}
                  helperText={this.state.errors.location}
                  placeholder="Enter your location"
                  fullWidth
                />
              </Box>
              <Box style={{ width: "100%" }}></Box>
            </Box>
            <Box sx={{ ...webStyles.aboutModalButtonBoxs }}>
              <Button
                sx={{ ...webStyles.aboutSaveModals }}
                data-test-id="save-botton"
                onClick={this.handleSaveData}
                disabled={this.isSaveDisabled()}
              >
                Save
              </Button>
            </Box>
          </Box>
        </Box>
        </DialogContent>
      </CustomDialog>
      </>
    )
  }
}

const webStyles = {
  modalwebStyles: {
    bgcolor: "#FFFFFF",
  },
  fieldsTitleTypo: {
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "22px",
    marginBottom: "5px",
    fontFamily: "Montserrat !important",
    "@media (max-width: 550px)": {
      lineHeight: "18px",
      fontSize: "14px",
    },
  },
  checkboxDivBox: {
    display: "flex",
    alignItems: "center",
    marginBottom: "10px",
  },
  checkBoxTitleText: {
    fontWeight: "500",
    lineHeight: "22px",
    fontSize: "16px",
    fontFamily: "Montserrat !important",
  },
  modalTitleTypoBox: {
    display: "flex",
    marginBottom: "20px",
    justifyContent: "space-between",
  },
  modalTitleTypo: {
    fontWeight: "500",
    lineHeight: "24.38px",
    fontSize: "20px",
    fontFamily: "Montserrat !important",
    "@media (max-width: 550px)": {
      lineHeight: "20px",
      fontSize: "18px",
    },
  },
  inputField: {
    lineHeight: "24px",
    fontSize: "16px",
    opacity: "1 !important",
    color: "#64748b !important",
    "& .MuiOutlinedInput-root": {
      borderColor: "#e2e8f0",
      borderRadius: "50px",
      "&:hover": { borderColor: "#cbd5e1" },
      "&.Mui-focused": {
        boxShadow: "0 0 0 3px rgba(103, 58, 183, 0.2)",
        borderColor: "#673ab7",
      },
    },
  },
  closeIcon: {
    p: 0,
    "& svg": {
      fontSize: "24px",
      fill: "#000",
    },
  },
  projectBox: {
    display: "flex",
    justifyContent: "space-between",
    gap: "15px",
    marginBottom: "15px",
    "@media (max-width: 550px)": {
      display: "flex",
      flexDirection: "column",
      marginBottom: "10px",
    },
  },
  projectMainContainer: {
    gap: "15px",
    display: "flex",
    marginBottom: "20px",
    justifyContent: "space-between",
    marginTop: "30px",
    "@media (max-width: 550px)": {
      display: "flex",
      flexDirection: "column",
    },
  },
  aboutModalButtonBoxs: {
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    marginTop: "30px",
  },
  aboutSaveModals: {
    fontWeight: 600,
    fontSize: "14px !important",
    color: "#fff !important",
    width: "360px !important",
    border: "1px solid currentColor",
    lineHeight: "24px !important",
    padding: "10px 39px !important",
    borderRadius: "32px",
    cursor: "pointer",
    textTransform: "none",
    opacity: 1,
    transition: "opacity 0.3s",
    background: "linear-gradient(90deg, #8077FF 0%, #652784 60%)",
    "&:disabled": {
      pointerEvents: "none",
      opacity: 0.5,
    },
    "@media (max-width: 1280px)": {
      fontSize: "12px",
    },
  },
}
